import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, Col, Row, Button, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
//import Button from '@material-ui/core/Button';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import TextField from '@material-ui/core/TextField';
import DataReactTable from './DataReactTable';
import ReactTableActions from './ReactTableActions';
import Spinner from 'react-bootstrap/Spinner';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import MenuItem from '@material-ui/core/MenuItem';
import ElectronicBillingProvider from './ElectronicBillingProvider';
import classnames from 'classnames';

const renderField = ({
    input, placeholder, type, meta: { touched, error },
}) => (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
        <input {...input} placeholder={placeholder} type={type} />
        {touched && error && <span className="form__form-group-error">{error}</span>}
    </div>
);

renderField.propTypes = {
    input: PropTypes.shape().isRequired,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string,
    }),
};

renderField.defaultProps = {
    placeholder: '',
    meta: null,
    type: 'text',
};

class FormInvoice extends Component {
    constructor() {
        super();
        this.state = {
            loading: true,
            isEdit: false,
            editInvoice: {},
            invoice: [],
            errors: {},
            activeTab: '1',
        }
    }

    toggle = (tab) => {
        const { activeTab } = this.state;
        if (activeTab !== tab) {
            this.setState({
                activeTab: tab,
            });
        }
    };

    componentDidMount() {
        this.loadInvoiceConfig();
    }

    loadInvoiceConfig = () => {
        this.setState({ loading: true, isEdit: false });
        fetch(process.env.REACT_APP_PUBLIC_URL + 'consecutivos/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log(data);
                this.setState({ invoice: data, loading: false });
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    handlePrefix = (value) => {
        this.setState({ ['editInvoice']: { ...this.state['editInvoice'], prefijo: value } });
    }

    handleConsecutive = (value) => {
        this.setState({ ['editInvoice']: { ...this.state['editInvoice'], consecutivo: value } });
    }

    handleLimit = (value) => {
        this.setState({ ['editInvoice']: { ...this.state['editInvoice'], limite: value } });
    }

    handleInit = (value) => {
        this.setState({ ['editInvoice']: { ...this.state['editInvoice'], inicio: value } });
    }

    handleStartDate = (value) => {
        this.setState({ ['editInvoice']: { ...this.state['editInvoice'], fecha_inicio: value } });
    }

    handleFinalDate = (value) => {
        this.setState({ ['editInvoice']: { ...this.state['editInvoice'], fecha_final: value } });
    }




    sendConfigInvoices = () => {
        fetch(process.env.REACT_APP_PUBLIC_URL + 'consecutivos/update', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(this.state.editInvoice)

        }).then(response => {
            return response.json();
        }).then(data => {
            alert("Factura configurada correctamente");
            this.loadInvoiceConfig();
        }).catch((error) => {
            console.error('Error:', error);
        });
    }

    render() {
        const { activeTab } = this.state;
        
        const tableData = {
            tableHeaderData: [{
                Header: 'NOMBRE',
                accessor: 'descripcion',
                disableGlobalFilter: true,
                width: 65,
            },
            {
                Header: 'PREFIJO',
                accessor: 'prefijo',
            },
            {
                Header: 'CONSECUTIVO',
                accessor: 'consecutivo',
            },
            {
                Header: 'No. INICIO',
                accessor: 'inicio',
            },
            {
                Header: 'No. LIMITE',
                accessor: 'limite',
            },
            {
                Header: 'FECHA DE INICIO',
                accessor: 'fecha_inicio',
            },
            {
                Header: 'FECHA FINAL',
                accessor: 'fecha_final',
            },
            ],
            tableRowsData: this.state.invoice

        };

        return (<Col md={12} lg={12}>
            <Card>
                <CardBody>

                    <div className="tabs tabs--bordered-top">
                        <div className="tabs__wrap">
                            <Nav tabs>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: activeTab === '1' })}
                                        onClick={() => {
                                            this.toggle('1');
                                        }}
                                    >
                                        Parametrización
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: activeTab === '2' })}
                                        onClick={() => {
                                            this.toggle('2');
                                        }}
                                    >
                                        Consecutivos
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            <TabContent activeTab={activeTab}>
                                <TabPane tabId="1">

                                    <ElectronicBillingProvider />
                                </TabPane>
                                <TabPane tabId="2">
                                    {this.state.isEdit ?
                                        <form className="material-form" >
                                            <div>
                                                <h4 className="react-table__column-header" style={{ marginLeft: 40, marginTop: 10, marginBottom: 20 }}> Editar</h4>
                                            </div>
                                            <TextField
                                                disabled
                                                style={{ marginLeft: 40, marginTop: 10, width: 150 }}
                                                id="history-number-standard-required"
                                                label="Nombre"
                                                type="text"
                                                className="material-form__field"
                                                value={typeof this.state.editInvoice.descripcion !== 'undefined' ? this.state.editInvoice.descripcion : ""}
                                            />
                                            <TextField
                                                style={{ margin: 10, width: 150 }}
                                                id="history-number-standard-required"
                                                label="Prefijo"
                                                type="text"
                                                className="material-form__field"
                                                value={typeof this.state.editInvoice.prefijo !== 'undefined' ? this.state.editInvoice.prefijo : ""}
                                                onChange={(e) => { this.handlePrefix(e.target.value) }}
                                            />
                                            <TextField
                                                style={{ margin: 10, width: 150 }}
                                                id="history-number-standard-required"
                                                label="Consecutivo"
                                                type="number"
                                                className="material-form__field"
                                                value={typeof this.state.editInvoice.consecutivo !== 'undefined' ? this.state.editInvoice.consecutivo : ""}
                                                onChange={(e) => { this.handleConsecutive(e.target.value) }}
                                            />
                                            <TextField
                                                style={{ margin: 10, width: 150 }}
                                                id="history-number-standard-required"
                                                label="No. Inicio"
                                                type="number"
                                                className="material-form__field"
                                                value={typeof this.state.editInvoice.inicio !== 'undefined' ? this.state.editInvoice.inicio : ""}
                                                onChange={(e) => { this.handleInit(e.target.value) }}
                                            />
                                            <TextField
                                                style={{ margin: 10, width: 150 }}
                                                id="history-number-standard-required"
                                                label="No. Limite"
                                                type="number"
                                                className="material-form__field"
                                                value={typeof this.state.editInvoice.limite !== 'undefined' ? this.state.editInvoice.limite : ""}
                                                onChange={(e) => { this.handleLimit(e.target.value) }}
                                            />
                                            <MuiPickersUtilsProvider utils={MomentUtils} >
                                                <DatePicker
                                                    style={{ margin: 10, width: 150 }}
                                                    label="Fecha de Inicio"
                                                    format="yyyy/MM/D"
                                                    views={["year", "month", "date"]}
                                                    value={this.state.editInvoice.fecha_inicio}
                                                    onChange={(date) => {
                                                        this.handleStartDate(new Date(date));
                                                    }}
                                                    animateYearScrolling
                                                />
                                            </MuiPickersUtilsProvider>
                                            <MuiPickersUtilsProvider utils={MomentUtils} >
                                                <DatePicker
                                                    style={{ margin: 10, width: 150 }}
                                                    label="Fecha de Final"
                                                    format="yyyy/MM/D"
                                                    views={["year", "month", "date"]}
                                                    value={this.state.editInvoice.fecha_final}
                                                    onChange={(date) => {
                                                        this.handleFinalDate(new Date(date));
                                                    }}
                                                    animateYearScrolling
                                                />
                                            </MuiPickersUtilsProvider>
                                            <Button
                                                style={{ margin: 20, marginLeft: 30 }}
                                                variant="contained"
                                                color="primary"
                                                onClick={() => {
                                                    this.sendConfigInvoices()
                                                }}
                                            >
                                                Guardar
                                            </Button>
                                        </form>
                                        : null}
                                    {this.state.loading ?
                                        <Spinner animation="border" variant="success" />
                                        :
                                        <DataReactTable title={'Configuracion'}
                                            reactTableData={tableData}
                                            ReactTableActions={ReactTableActions}
                                            Callback={(data) => {
                                                this.setState({ editInvoice: data, isEdit: true });
                                            }} />
                                    }
                                </TabPane>
                            </TabContent>
                        </div>
                    </div>
                </CardBody>
            </Card>
        </Col>)
    }
}

export default reduxForm({
    form: 'invoice_ips_form', // a unique identifier for this form
})(withTranslation('common')(FormInvoice));